/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Productstrings1Inputs */

const de__field_productstrings1 = /** @type {(inputs: _Field_Productstrings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkte`)
};

/**

* @param {_Field_Productstrings1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_productstrings1 = /** @type {((inputs?: _Field_Productstrings1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Productstrings1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_productstrings1(inputs)
});
export { _field_productstrings1 as "_field_productStrings" }